import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { BottomNav } from './BottomNav';

export const MainLayout = () => {
  const location = useLocation();
  const hideBottomNav = location.pathname === '/scan';

  return (
    <div
      className="min-h-screen bg-obsidian text-cream-100"
      style={{ paddingBottom: hideBottomNav ? '0px' : 'calc(6rem + env(safe-area-inset-bottom, 0px))' }}
    >
      <main className="max-w-md mx-auto min-h-screen relative">
        <Outlet />
      </main>
      {!hideBottomNav && <BottomNav />}
    </div>
  );
};
